import { APOLLO_FETCH_POLICY } from '@/constants/apollo';
import { setDefaultHeader } from '@/publicSearch/graphql/headers';
import {
  LogicalOperator,
  OperatorOption,
  SortDirection,
} from '@/components/publicSearch/constants';
import type {
  ComparisonOperator,
  LotAnimalEbvFilterField,
  LotAnimalEbvSortField,
  SortDirectionOrder,
} from '@/graphqlClient/types';

type BuildAnimalLotEbvsQueryOptionsParams = {
  animalId?: string | number | null;
  orgId?: string | number | null;
  enabled: boolean;
};

/**
 * Builds the shared Apollo query options (request input, headers, fetch policy
 * and skip flag) used to fetch lot animal EBVs filtered by a single animal.
 */
export function buildAnimalLotEbvsQueryOptions({
  animalId,
  orgId,
  enabled,
}: BuildAnimalLotEbvsQueryOptionsParams) {
  return {
    skip: !enabled,
    variables: {
      requestInput: {
        pagination: {
          currentPage: 1,
          pageSize: 200,
        },
        filterGroups: [
          {
            filters: [
              {
                field: 'ANIMAL_ID' as LotAnimalEbvFilterField,
                operator: OperatorOption.equals.value as ComparisonOperator,
                value: String(animalId),
              },
            ],
            groups: [],
            logicalOperator: LogicalOperator.and,
          },
        ],
        sortOptions: [
          {
            field: 'SALE_ID' as LotAnimalEbvSortField,
            direction: SortDirection.desc as SortDirectionOrder,
          },
        ],
      },
    },
    context: {
      headers: setDefaultHeader(orgId ?? ''),
    },
    fetchPolicy: APOLLO_FETCH_POLICY.NETWORK_ONLY,
  };
}
